// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___YVePU","input":"style__input___36y3c","inputMemorial":"style__inputMemorial___2Hslr","label":"style__label___wl0IJ","labelMemorail":"style__labelMemorail___1ezam","labelShrink":"style__labelShrink___1DB4k"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/uq-forms/components/text-field/style.css
// module id = 782
// module chunks = 0